// ** UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// ** Types
import type { SxProps, Theme } from '@mui/material/styles';
import type { DashboardEmployeeAccessSection } from './types';

// ** Components
import Link from '@/components/common/Link';

type DashboardEmployeeAccessPanelProps = {
	section: DashboardEmployeeAccessSection;
	sx?: SxProps<Theme>;
};

const DashboardEmployeeAccessPanel = ({ section, sx }: DashboardEmployeeAccessPanelProps) => (
	<Box
		component="section"
		sx={[
			{
				display: 'flex',
				flexDirection: { xs: 'column', md: 'row' },
				alignItems: { xs: 'flex-start', md: 'center' },
				justifyContent: 'space-between',
				gap: { xs: 2, md: 4 },
				backgroundColor: 'common.white',
				borderRadius: '8px',
				p: { xs: 4, md: 8 }
			},
			...(Array.isArray(sx) ? sx : sx ? [sx] : [])
		]}
	>
		<Typography variant="panel-heading" component="h2" sx={{ color: 'common.black' }}>
			{section.title}
		</Typography>

		<Box
			sx={{
				width: { xs: '100%', md: 'auto' },
				textAlign: { xs: 'left', md: 'right' },
				'& a': {
					display: 'inline-block',
					color: 'text.secondary',
					textDecoration: 'underline',
					textDecorationSkipInk: 'none',
					textUnderlineOffset: '2px',
					textDecorationThickness: '1px',
					transition: 'opacity 180ms ease, text-underline-offset 180ms ease, text-decoration-thickness 180ms ease'
				},
				'& a:hover, & a:focus-visible': {
					color: 'text.secondary',
					opacity: 0.72,
					textUnderlineOffset: '3px',
					textDecorationThickness: '2px'
				}
			}}
		>
			<Link href={section.cta.href} passHref style={{ textDecoration: 'underline' }}>
				<Typography variant="body-md" component="span" sx={{ color: 'text.secondary', textDecoration: 'inherit' }}>
					{section.cta.label}
				</Typography>
			</Link>
		</Box>
	</Box>
);

export default DashboardEmployeeAccessPanel;
